import { createSlice, PayloadAction } from "@reduxjs/toolkit";
import { IGroup } from "src/models/Products/Group.models";

interface GroupState {
  groups: IGroup[];
  groupToEdit: IGroup | null;
}

const initialState: GroupState = {
  groups: [],
  groupToEdit: null,
};

const GroupSlice = createSlice({
  name: "Group",
  initialState,
  reducers: {
    setGroupList: (state, action: PayloadAction<IGroup[]>) => {
      state.groups = action.payload;
    },
    concatListGroup: (state: GroupState, action: PayloadAction<IGroup[]>) => {
      state.groups = [...state.groups.concat(action.payload)];
    },
    setGroupToEdit: (state, action: PayloadAction<IGroup | null>) => {
      state.groupToEdit = action.payload;
    },
    addGroup: (state, action: PayloadAction<IGroup>) => {
      state.groups.push(action.payload);
    },
    addGroups: (state, action: PayloadAction<IGroup[]>) => {
      state.groups.push(...action.payload);
    },
    updateGroup: (state, action: PayloadAction<IGroup>) => {
      let itemIndex = state.groups.findIndex(
        item => item.groupId === action.payload.groupId
      );
      if (itemIndex !== -1) state.groups[itemIndex] = action.payload;
    },
    deleteGroup: (state, action: PayloadAction<number>) => {
      const newArray = state.groups.filter(
        item => item.groupId !== action.payload
      );
      state.groups = newArray;
    },
  },
});

export const {
  setGroupList,
  concatListGroup,
  setGroupToEdit,
  addGroup,
  addGroups,
  updateGroup,
  deleteGroup,
} = GroupSlice.actions;

export default GroupSlice.reducer;
